import { Component, OnInit } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { HttpEventType, HttpClient, HttpRequest, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { element } from 'protractor';


@Component({
  selector: 'app-login',
  templateUrl: '../Dashboard/Dashboard.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css'],
})
export class DashboardComponent implements OnInit {
  innerWidth: number;
  get_url: string = '';
  constructor() { this.innerWidth = 100; }
  ngOnInit()
  {
    this.get_url = window.location.origin;
    if (this.get_url == "https://localhost:44335") {
             var a =document.getElementById("mainbox");
                    a.style.backgroundColor = "#cc4141";

             var footer = document.getElementById("footer");
                          footer.style.background = "#cc4141";

             var header = document.getElementById("header");
                          header.style.background = "#cc4141";

     // var mnu_Reports = document.getElementsByTagName("ul[_ngcontent-c2] li[_ngcontent-c2]");

                                
    }
    else if (this.get_url == "https://inn-flowmgt-test.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

    }
    else if (this.get_url == "https://inn-flowmgt-staging.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#ed7d31";

      var footer = document.getElementById("footer");
      footer.style.background = "#ed7d31";

      var header = document.getElementById("header");
      header.style.background = "#ed7d31";
    }
  }

  
}




// WEBPACK FOOTER //
// ./src/app/Dashboard/DashboardComponent.ts